<template>
  <my-dialog :maxHeight="1600" v-model="openModal">
    <template v-slot:content>
      <v-card width="100%" height="100%" elevation="0" class="mb-4 pa-4">
        <v-card-title class="d-flex justify-space-between">
          <div>
            <h3 class="mb-1">{{ game.name }}</h3>
            <small class="grey--text">
              מזהה: {{ game._id }} | מייל יוצר:
              {{ getEmailUser(game.user) }}</small
            >
          </div>
          <v-btn icon @click="remove" v-if="game.credit">
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <div>
            <v-form ref="form">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="localCredit.type"
                    :items="gameTypes"
                    label="סוג המשחק"
                    outlined
                    @change="onTypeChange"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" v-if="localCredit.type === 'phones'">
                  <v-text-field
                    v-model="localCredit.room"
                    label="מספר חדר"
                    type="number"
                    outlined
                    :min="1011"
                    :max="MaxRoomNumber"
                    :rules="[
                      v =>
                        (v !== null &&
                          v !== '' &&
                          v >= 1011 &&
                          v <= MaxRoomNumber) ||
                        `Value must be between 1011 and ${MaxRoomNumber}`,
                    ]"
                    @click:append="findEmptyRoom"
                    append-icon="mdi-home-search"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-row>
                    <v-col>
                      <label class="mb-2 d-block">הגבלת משתתפים</label>
                      <v-radio-group v-model="localCredit.isLimitPlayers">
                        <v-radio label="ללא הגבלה" :value="false"></v-radio>
                        <v-radio label="הגבלה" :value="true"></v-radio>
                      </v-radio-group>
                    </v-col>
                    <v-col
                      class="d-flex align-end"
                      cols="8"
                      v-if="localCredit.isLimitPlayers"
                    >
                      <v-text-field
                        v-model="localCredit.limitPlayers"
                        label="מספר משתתפים"
                        type="number"
                        min="1"
                        outlined
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12" sm="6" class="d-flex align-end">
                  <v-text-field
                    v-model="localCredit.expiresAt"
                    label="תאריך פקיעת תוקף"
                    type="datetime-local"
                    outlined
                  />
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions class="justify-end">
              <v-btn color="success" @click="saveCredit">שמור</v-btn>
            </v-card-actions>
          </div>

          <div v-if="!game.credit" class="text-center error--text">
            <p class="my-4">למשחק זה אין רישיון פעיל.</p>
          </div>
        </v-card-text>
        <v-card-actions v-if="err" class="justify-end">
          <v-row>
            <v-col class="error--text text-center">
              {{ err }}
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </template>
  </my-dialog>
</template>
<script>
import MyDialog from '@/components/MyDialog.vue'
import axios from 'axios'
import dayjs from 'dayjs'

export default {
  name: 'credit-handler',
  components: { MyDialog },
  props: {
    value: Boolean,
    credit: Object,
    gameId: String,
    email: String,
  },
  data() {
    console.log(this.gameId)

    return {
      isCreating: true,
      localCredit: {
        type: 'phones',
        room: '',
        limitPlayers: '',
        isLimitPlayers: true,
        expiresAt: dayjs().add(3, 'day').format('YYYY-MM-DDTHH:mm'),
        game: this.gameId,
      },
      MaxRoomNumber: 5000,
      err: null,
    }
  },
  computed: {
    game() {
      return this.$store.getters.games.find(g => g._id === this.gameId)
    },
    gameTypes() {
      return [
        { text: 'משחק בטלפונים', value: 'phones' },
        { text: 'משחק בשלטים', value: 'clickers' },
      ]
    },

    openModal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    async findEmptyRoom() {
      this.localCredit.room = await axios
        .get('/credit/find-empty-room')
        .then(res => res.data)
    },
    getEmailUser(id) {
      return this.$store.getters.userById(id)?.email
    },
    createErr(msg) {
      this.err = msg
      setTimeout(() => {
        this.err = null
      }, 2000)
      return
    },
    onTypeChange(type) {
      if (type !== 'phones') {
        this.localCredit.room = ''
      }
    },

    async saveCredit() {
      if (!this.$refs.form.validate()) {
        return this.createErr('יש להזין את כל הפרטים')
      }
      const action = this.game?.credit ? 'credit/update' : 'credit/store'
      await this.$store.dispatch(action, this.localCredit)
      this.$emit('save')
    },
    async remove() {
      if (confirm(`האם למחוק את הרישיון של "${this.game.name}"?`)) {
        await this.$store.dispatch(
          'credit/destroy',
          this.game.credit._id || this.game.credit
        )
      }
      this.$emit('save')
    },
  },
  mounted() {
    if (this.game.credit) {
      this.localCredit = { ...this.localCredit, ...this.game.credit }
      this.localCredit.expiresAt = dayjs(this.localCredit.expiresAt).format(
        'YYYY-MM-DDTHH:mm'
      )
    }
  },
}
</script>

<style scoped>
.creditd {
  border-left: 5px solid #4caf50;
}
.uncreditd {
  border-left: 5px solid #aaa;
}
</style>
